import { useContext} from 'react';

import { LocaleContext } from 'contexts';

export const useLocalized = (strings) => strings[useContext(LocaleContext)];
